import { render, staticRenderFns } from "./BackToTop.vue?vue&type=template&id=5903bff9&scoped=true"
import script from "./BackToTop.vue?vue&type=script&lang=js"
export * from "./BackToTop.vue?vue&type=script&lang=js"
import style0 from "./BackToTop.vue?vue&type=style&index=0&id=5903bff9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5903bff9",
  null
  
)

export default component.exports